import React, { useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/config';

const SchemeDateRangeApi = ({ areaId, schemeId, onDataFetched }) => {
  useEffect(() => {
    if (areaId && schemeId) {
      const fetchData = async () => {
        try {
          const response = await axios.post(`${API_URL}/samruddhi_v2/get_scheme_date_range_for_selected`, {
            area_id: areaId,
            scheme_id: schemeId
          });
          const data = response.data;
          onDataFetched(data);
        } catch (error) {
          // console.error('Error fetching scheme date range data:', error);
        }
      };

      fetchData();
    }
  }, [areaId, schemeId]);

  return null;
};

export default SchemeDateRangeApi;
